import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsKudoHighlightedSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M22 16.672V14l.23-.244A2.82 2.82 0 0020.18 9H12.9l.743-6.082A2.602 2.602 0 0011.061 0c-.341 0-.651.2-.791.511l-3.74 8.31a1 1 0 01-.312.39L1.4 12.825a1 1 0 00-.4.8V19a2 2 0 002 2h2.702l2.494 1.664a2 2 0 001.11.336H18a3 3 0 003-3v-1.5l.414-.414A2 2 0 0022 16.672z"
        fill=""
      />
    </svg>
  )
);
SvgActionsKudoHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsKudoHighlightedSmall;
